import { api } from "../api";

/**
 * findAllCnhCategoriesListResponse - Function that finds on database all cnh categories as select list   
 * /cnh-categories    
 * method GET 
 * @async-function
 */
const findAllCnhCategoriesListResponse = async (token: string) => {
    const response = await api.get(
        `/cnh-categories`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default findAllCnhCategoriesListResponse;